var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoMobileLikes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "13px",
    viewBox: "0 0 15 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0F4D78A7-448C-46EE-855D-2E23DE8BD25E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-Home",
    transform: "translate(-152.000000, -699.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card-5",
    transform: "translate(10.000000, 621.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(143.000000, 77.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "outline-thumb_up-24px",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L13,0 L13,13 L0,13 L0,0 Z M0,0 L13,0 L13,13 L0,13 L0,0 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.875,11.375 C4.27916667,11.375 3.79166667,10.8875 3.79166667,10.2916667 L3.79166667,4.875 C3.79166667,4.57708333 3.91083333,4.30625 4.10583333,4.11125 L7.67541667,0.541666667 L8.24958333,1.11041667 C8.39583333,1.25666667 8.48791667,1.4625 8.48791667,1.68458333 L8.47166667,1.85791667 L7.95708333,4.33333333 L11.375,4.33333333 C11.9708333,4.33333333 12.4583333,4.82083333 12.4583333,5.41666667 L12.4583333,6.5 C12.4583333,6.64083333 12.43125,6.77083333 12.3825,6.89541667 L10.7466667,10.7141667 C10.5841667,11.1041667 10.1995833,11.375 9.75,11.375 L4.875,11.375 Z M0.541666667,4.875 L2.70833333,4.875 L2.70833333,11.375 L0.541666667,11.375 L0.541666667,4.875 Z",
    id: "Shape",
    stroke: "#191919",
    strokeWidth: 1.2,
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMobileLikes);
export default __webpack_public_path__ + "static/media/ico_mobile_likes.a123c3a3cfe4ebfb8f3b45fd9d9d67ee.svg";
export { ForwardRef as ReactComponent };